import React from "react";

const NodeHeader = ({ handleClick }) => {
  return (
    <div className="flex flex-col items-center gap-2">
      <h2 className="font-bold text-2xl leading-9 lg:text-[2rem] text-black lg:leading-[38px] text-center dark:text-white">
        Enjoy a Lifetime Rewards with XBR Founder's Node
      </h2>
      <p className="text-xs leading-[18px] lg:text-sm lg:leading-[21px] text-semiBlack text-center dark:text-semiWhite">
        Be part of history in the making with the XBR Founder's Node,
        experiencing lifetime rewards and exclusive perks for early
        participants.
      </p>
    </div>
  );
};

export default NodeHeader;
